<template>
  <div>
    <p v-if="isMessageVisible">
      {{ message }}
    </p>

    <template v-if="isRacesVisible">
      <p class="mb-1">
        Количество заездов: {{ raceAmount | getFormattedNumber }}
      </p>

      <derby-races-table
        :derbyId="derbyId"
        :races="races"
      />

      <b-pagination-nav
        v-if="pageAmount > 1"
        :number-of-pages="pageAmount"
        :link-gen="linkGen"
        first-number
        last-number
        use-router
        class="mb-4"
      />
    </template>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../../http-common.js';
import notifier from '../../notifier.js';

import LoadingIndicator from '../LoadingIndicator.vue';
import DerbyRacesTable from './DerbyRacesTable.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'DerbyRaceList',

  components: {
    LoadingIndicator,
    DerbyRacesTable,
  },

  props: {
    derbyId: {
      type: Number,
      required: true,
    },

    page: {
      type: Number,
      default: 1,
    },

    pageSize: {
      type: Number,
      default: 20,
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {?number} */
      raceAmount: null,

      /** @type {?Array} */
      races: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {boolean} */
    isMessageVisible() {
      return this.message !== null;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      if(this.raceAmount === 0) {
        return 'Нет заездов.';
      }

      return null;
    },

    /** @returns {boolean} */
    isRacesVisible() {
      const races = this.races;
      if(races === null) {
        return false;
      }

      return races.length > 0;
    },

    /** @returns {number} */
    pageAmount() {
      const raceAmount = this.raceAmount;
      if(raceAmount === null) {
        return 0;
      }

      return Math.ceil(raceAmount / this.pageSize);
    },
  },

  created() {
    this.loadRaces();
  },

  watch: {
    page() {
      this.loadRaces();
    },
  },

  methods: {
    loadRaces() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const derbyId = this.derbyId;
      const url = `/derbies/${derbyId}/races`;

      const params = {
        limit: this.pageSize,
      };

      const offset = calcOffset(this.page, this.pageSize);
      if(offset > 0) {
        params.offset = offset;
      }

      HTTP.get(
        url,
        {params: params}
      )
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.raceAmount = data.raceAmount;
        this.races = data.races;

        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
  },
}

/**
 * @param {number} pageNum
 * @param {number} pageSize
 * @returns {number}
 */
function calcOffset(pageNum, pageSize) {
  const prevPageAmount = pageNum - 1;
  return prevPageAmount * pageSize;
}
</script>
